export const ErrorText = ({ text }: { text: string }) => {
  return <p className="text-[14px] font-normal pt-1 text-red-200">{text}</p>;
};
